/* src/app/pages/data-compilation/previous-data-summary/previous-data-summary.component.scss */
table {
  width: 100%;
}
.col-md-4 {
  margin-left: auto;
  margin-bottom: 10px;
}
.mat-mdc-form-field {
  --mat-mdc-form-field-floating-label-scale: 0.75;
  display: block;
  flex-direction: column;
  min-width: 0;
  text-align: left;
}
::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
}
/*# sourceMappingURL=previous-data-summary.component.css.map */
